import { render } from "./EnergyConfig.vue?vue&type=template&id=0457edca&scoped=true"
import script from "./EnergyConfig.vue?vue&type=script&lang=js"
export * from "./EnergyConfig.vue?vue&type=script&lang=js"

import "./EnergyConfig.vue?vue&type=style&index=0&id=0457edca&lang=scss&scoped=true"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0457edca"]])

export default __exports__